"use strict";

import * as bindings from "./bindings";
import * as handlers from "./handlers";
var init = function init() {
  if (!window.intLoginPage) {
    handlers.checkCookie("intValidated");
  }
  bindings.bindActions();
};
export default init;
